import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setInputTypeAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";

const KeyPresser = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const setInputType = payload => { dispatch( setInputTypeAction( payload ) ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };

  useEffect( () => {
    if ( TYPE.DEVICE.PC === deviceInfo.type && ! answerEditor.isShow ) {
      document.addEventListener( 'keydown', changeAnswerKey );
      return () => {
        document.removeEventListener( 'keydown', changeAnswerKey );
      };
    }
  }, [ deviceInfo.type, answerEditor.isShow ] );

  const changeAnswerKey = ( event ) => {
    console.log(event);
    switch ( event.key ) {
      case 'x' :
      case '+' :
      case '-' :
      case '*' :
      case '/' :
      case '<' :
      case '>' :
      case '=' :
      case ':' :
      case '.' :
      case '0' :
      case '1' :
      case '2' :
      case '3' :
      case '4' :
      case '5' :
      case '6' :
      case '7' :
      case '8' :
      case '9' :
      case 'Backspace' :
        convertAnswerKey( event.key );
        break;
    }
  };

  const convertAnswerKey = ( key ) => {
    let convertedKey = key;
    switch ( convertedKey ) {
      case '*' :
        convertedKey = '\\times';
        break;
    }
    setAnswerEditor( { answerKey : `${ convertedKey }?${ Date.now() }` } );
    setInputType( TYPE.INPUT.KEYBOARD );
    props.onCount();
  };

  return props.children || null;

};

export default KeyPresser;
